import InputField from './InputField'
import Dlg from './Dlg'
import Loader from './Loader/Loader'

import { InputLabel, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { closeEditDlg, setEditUserErrorMessage, setEditUserEmail, setEditUserFirstName, setEditUserSecondName } from '../redux/features/editUserDlgSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import useToken from '../hooks/useToken'
import { usePatchUserMutation } from '../redux/api/usersApi'

const Label = styled(InputLabel)(({ theme }) => ({
  color: '#4D5E80',
  fontSize: 14,
  fontWeight: 700,
  marginBottom: '13px',
  marginTop: '8px'
}))

const EditUserDlg: React.FC = () => {
  const photoUrl = ''
  const [emailError, setEmailError] = useState<boolean>(false)
  const [firstNameError, setFirstNameError] = useState<boolean>(false)
  const [secondNameError, setSecondNameError] = useState<boolean>(false)

  const dispatch = useDispatch()
  const dlg = useSelector((state: any) => state.editUserDlgState)

  const {
    xsrf,
    isLoading: isLoadingXSRF
  } = useToken()

  const [editUser, {
    isLoading: isLoadingEdit,
    isSuccess,
    isError,
    error
  }] = usePatchUserMutation()

  function resetDlg () {
    setEmailError(false)
    setFirstNameError(false)
    setSecondNameError(false)
    dispatch(setEditUserErrorMessage(''))
  }

  const handleClose = () => {
    resetDlg()
    dispatch(closeEditDlg())
  }

  const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g

  const handleSubmit = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    let errorMessage = ''
    dispatch(setEditUserErrorMessage(''))
    if (!dlg.editUserEmail.match(isValidEmail)) {
      setEmailError(true)
      errorMessage = 'Incorrect email'
    }
    if (!dlg.editUserFirstName) {
      setFirstNameError(true)
      errorMessage = errorMessage ? `${String(errorMessage)}, First Name required` : 'First Name required'
    }
    if (!dlg.editUserSecondName) {
      setSecondNameError(true)
      errorMessage = errorMessage ? `${String(errorMessage)}, Last Name required` : 'Last Name required'
    }
    if (!errorMessage) {
      await editUser({
        email: dlg.editUserEmail,
        firstName: dlg.editUserFirstName,
        secondName: dlg.editUserSecondName,
        photoUrl,
        id: dlg.editUserId,
        token: xsrf
      }).then(() => {
      }).catch(() => {
      })
    } else {
      dispatch(setEditUserErrorMessage(errorMessage))
    }
  }

  useEffect(() => {
    if (isSuccess) {
      resetDlg()
      dispatch(closeEditDlg())
    }
    if (isError) {
      setEmailError(true)
      setFirstNameError(true)
      setSecondNameError(true)
    }
  }, [isLoadingEdit])

  return (
    <>
    <Dlg
      name='Edit User'
      open={dlg.openEditDialog}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      errorMessage= { dlg.editUserErrorMessage ?? '' }
      errorResponse={ emailError && firstNameError && secondNameError && !dlg.editUserErrorMessage ? error : undefined }
    >
      <>
        {isLoadingEdit || isLoadingXSRF
          ? <Box height = '100%' width = '100%' sx={{ my: 10 }}><Loader /></Box>
          : <>
        <Box sx={{ py: 1 }}>
          <Label htmlFor='email'>Email</Label>
          <InputField autoFocus required id='email' fullWidth sx={{ py: '3px' }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setEmailError(false)
              dispatch(setEditUserErrorMessage(''))
              dispatch(setEditUserEmail(e.target.value))
            }}
            value={dlg.editUserEmail}
            type='text'
            error={emailError}
            aria-invalid={emailError}
          />
        </Box>
        <Box sx={{ py: 1 }}>
          <Label htmlFor='firstName'>First Name</Label>
          <InputField required id='firstName' fullWidth sx={{ py: '3px' }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFirstNameError(false)
              dispatch(setEditUserErrorMessage(''))
              dispatch(setEditUserFirstName(e.target.value))
            }}
            value={dlg.editUserFirstName}
            type='text'
            error={firstNameError}
            aria-invalid={firstNameError}
          />
        </Box>
        <Box sx={{ py: 1 }}>
          <Label htmlFor='secondName'>Last Name</Label>
          <InputField required id='secondName' fullWidth sx={{ py: '3px' }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSecondNameError(false)
              dispatch(setEditUserErrorMessage(''))
              dispatch(setEditUserSecondName(e.target.value))
            }}
            value={dlg.editUserSecondName}
            type='text'
            error={secondNameError}
            aria-invalid={secondNameError}
          />
        </Box>
        </>
        }
      </>
    </Dlg>
    </>
  )
}

export default EditUserDlg
